module.exports = __webpack_public_path__ + "img/candies.c0850453.png";